
  import {Component, Vue} from 'vue-property-decorator';

  @Component
  export default class ExternalAppRedirect extends Vue {
    externalLink = 'https://qrco.de/beZwmo';
  }
